import { useEffect, useRef, ReactNode } from "react";
import { createPortal } from "react-dom";

import { Paragraph } from "@rsuite/icons";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "rsuite";

const modalRoot = document.querySelector("#modal-root") as HTMLElement;

interface ModalProps {
  children?: ReactNode;
}

export const ModalLayout = ({ children }: ModalProps) => {
  const navigate = useNavigate();
  const el = useRef(document.createElement("div"));

  useEffect(() => {
    // Use this in case CRA throws an error about react-hooks/exhaustive-deps
    const current = el.current;

    // We assume `modalRoot` exists with '!'
    modalRoot!.appendChild(current);
    return () => void modalRoot!.removeChild(current);
  }, []);

  return createPortal(children,
    // <Modal open={true} onClose={() => navigate(-1)}>
    //   <Modal.Body>{children}</Modal.Body>
    // </Modal>,
    el.current
  );
};

export default Modal;
